module.exports = __webpack_public_path__ + "img/logo-smart-378.fb233969.svg";